var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { GET_NUMBERS, GET_PRICING_NUMBERS, GET_SINGLE_PRICING, GetNumbersFailureAction, GetNumbersSuccessAction, GetPricingNumbersFailureAction, GetPricingNumbersSuccessAction, GetSinglePricingFailureAction, GetSinglePricingSuccessAction, ORDER_INITIAL_NUMBER, ORDER_INITIAL_NUMBER_SUCCESS, ORDER_NUMBER, ORDER_NUMBER_PAYMENT, OrderInitialNumberFailureAction, OrderInitialNumberSuccessAction, OrderNumberFailureAction, OrderNumberPaymentAction, REGION_FOR_NUMBER_CHOSEN } from './pricing-numbers.action';
import { PricingNumbersService } from '../../shared/services/pricing-numbers.service';
import { GetNumbersFromRegionState } from './pricing-numbers';
import { Router } from '@angular/router';
import { MsisdnService } from '../../shared/msisdn/msisdn.service';
import { AccountService } from '../../shared/services/account.service';
import { Ng1ModalService } from '../../shared/ng1/ng1-modal.service';
import { PaymentService } from '../../shared/services/payment.service';
import { GoToNextStateAction } from "../../first-steps/first-steps.actions";
var PricingNumbersEffects = /** @class */ (function () {
    function PricingNumbersEffects(actions$, pricingNumbersService, router, msisdnService, accountService, ng1ModalService, paymentService) {
        var _this = this;
        this.actions$ = actions$;
        this.pricingNumbersService = pricingNumbersService;
        this.router = router;
        this.msisdnService = msisdnService;
        this.accountService = accountService;
        this.ng1ModalService = ng1ModalService;
        this.paymentService = paymentService;
        this.getPricingNumbers$ = this.actions$.pipe(ofType(GET_PRICING_NUMBERS), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.pricingNumbersService
                .getPricingNumbersWithDocuments(payload)
                .pipe(map(function (response) { return new GetPricingNumbersSuccessAction(response); }), catchError(function (error) { return of(new GetPricingNumbersFailureAction(error)); }));
        }));
        this.getNumbers$ = this.actions$.pipe(ofType(GET_NUMBERS), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.pricingNumbersService
                .getPhoneNumbers(payload.pricingId, payload.searchText)
                .pipe(map(function (response) { return new GetNumbersSuccessAction(response); }), catchError(function (error) { return of(new GetNumbersFailureAction(error)); }));
        }));
        this.getSinglePricing$ = this.actions$.pipe(ofType(GET_SINGLE_PRICING), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.pricingNumbersService
                .getSinglePricing(payload.pricingId)
                .pipe(map(function (response) { return new GetSinglePricingSuccessAction(response); }), catchError(function (error) { return of(new GetSinglePricingFailureAction(error)); }));
        }));
        this.orderNumber$ = this.actions$.pipe(ofType(ORDER_NUMBER), map(function (action) { return action.payload; }), map(function (payload) { return _this.mapToAssignRequest(payload, 'ORDER'); }), switchMap(function (payload) {
            return _this.msisdnService.limitsExceeded().pipe(map(function (limitsExceeded) { return ({
                limitsExceeded: limitsExceeded,
                payload: payload
            }); }));
        }), switchMap(function (_a) {
            var limitsExceeded = _a.limitsExceeded, payload = _a.payload;
            if (limitsExceeded) {
                _this.ng1ModalService.lazyModalService.showUpgradeAccountModal();
                return;
            }
            return _this.msisdnService
                .assign(payload)
                .pipe(map(function (payment) { return new OrderNumberPaymentAction(payment, payload); }), catchError(function (error) { return of(new OrderNumberFailureAction(error)); }));
        }));
        this.orderInitialNumber$ = this.actions$.pipe(ofType(ORDER_INITIAL_NUMBER), map(function (action) { return action.payload; }), map(function (payload) { return _this.mapToAssignRequest(payload, 'GET_INITIAL'); }), switchMap(function (payload) {
            return _this.msisdnService
                .assignInitial(payload)
                .pipe(switchMap(function () { return [
                new OrderInitialNumberSuccessAction(),
                new GoToNextStateAction()
            ]; }), catchError(function (error) { return of(new OrderInitialNumberFailureAction(error)); }));
        }));
        this.afterInitialNumber$ = this.actions$.pipe(ofType(ORDER_INITIAL_NUMBER_SUCCESS), tap(function () {
            _this.accountService.changeAccountConfig({ data: true });
        }));
        this.afterOrderNumberPayment$ = this.actions$.pipe(ofType(ORDER_NUMBER_PAYMENT), tap(function (action) {
            var selectedMsisdnDisplayedValue = action.payload.selectedMsisdnDisplayedValue;
            _this.paymentService.handleSubscriptionPayment(action.payment, "phone-numbers-" + (selectedMsisdnDisplayedValue || ''));
        }));
        this.redirectAfterRegionForNumberChosen$ = this.actions$.pipe(ofType(REGION_FOR_NUMBER_CHOSEN), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.pricingNumbersService.availableNumbersState(payload.pricingId).pipe(tap(function (response) {
                var baseUrl = payload.fullyConfigured ? '/get-new-number' : '/get-first-new-number';
                if (response === GetNumbersFromRegionState.CAN_GET_RANDOM_NUMBER) {
                    _this.router.navigate([baseUrl, 'pricing', payload.pricingId, 'final-step']);
                }
                else {
                    _this.router.navigate([baseUrl, 'numbers', payload.pricingId]);
                }
            }));
        }));
    }
    PricingNumbersEffects.prototype.mapToAssignRequest = function (payload, actionType) {
        var request = {
            label: payload.label,
            pricingId: payload.pricingId,
            actionType: actionType
        };
        if (payload.selectedMsisdn) {
            request.selectedMsisdnDisplayedValue = payload.selectedMsisdn.number;
            request.selectedMsisdnId = payload.selectedMsisdn.id;
        }
        return request;
    };
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PricingNumbersEffects.prototype, "getPricingNumbers$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PricingNumbersEffects.prototype, "getNumbers$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], PricingNumbersEffects.prototype, "getSinglePricing$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], PricingNumbersEffects.prototype, "orderNumber$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], PricingNumbersEffects.prototype, "orderInitialNumber$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], PricingNumbersEffects.prototype, "afterInitialNumber$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], PricingNumbersEffects.prototype, "afterOrderNumberPayment$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], PricingNumbersEffects.prototype, "redirectAfterRegionForNumberChosen$", void 0);
    return PricingNumbersEffects;
}());
export { PricingNumbersEffects };
